import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { environment } from 'src/environments/environment';
import { CoreApiLoaderService } from './api/services/core-api-loader.service';
import { ApiUtilsService } from './api/services/api-utils.service';
import { CompanyApiService } from './api/services/company-api.service';
import { PresentationApiService } from './api/services/presentation-api.service';
import { StorageApiService } from './api/services/storage-api.service';
import { DedupingGeneratorService } from './app-common/services/deduping-generator.service';
import { GapiClientLoaderGeneratorService } from './app-common/services/gapi-client-loader-generator.service';
import { GapiLoaderService } from './app-common/services/gapi-loader.service';
import { RejectOnTimeoutService } from './app-common/services/reject-on-timeout.service';
import { CompanyStateService } from './auth/services/company-state.service';
import { OpenidConnectService } from './auth/services/openid-connect.service';
import { RvTokenStoreService } from './auth/services/rv-token-store.service';
import { UserAuthService } from './auth/services/user-auth.service';
import { UserStateService } from './auth/services/user-state.service';
import { FeaturesService } from './components/plans/features.service';
import { RvshareAppDetectionService } from './screen-sharing/services/rvshare-app-detection.service';
import { AddressUtilsService } from './shared/services/address-utils.service';
import { AddressService } from './shared/services/address.service';
import { BroadcasterService } from './shared/services/broadcaster.service';
import { ContactUtilsService } from './shared/services/contact-utils.service';
import { GeodataService } from './shared/services/geodata.service';
import { LocalStorageHelperService } from './shared/services/local-storage-helper.service';
import { ObjectHelperService } from './shared/services/object-helper.service';
import { ValidationService } from './shared/services/validation.service';
import { DownloadService } from './storage/services/download.service';
import { EncodingService } from './storage/services/encoding.service';
import { FileUploaderService } from './storage/services/file-uploader.service';
import { StorageUtilsService } from './storage/services/storage-utils.service';

angular.module('risevision.common.config').value('environment', environment);

angular
  .module('risevision.apps.services')
  .factory('companyState', downgradeInjectable(CompanyStateService));

angular
  .module('risevision.apps.services')
  .factory('broadcaster', downgradeInjectable(BroadcasterService));

angular
  .module('risevision.apps.services')
  .factory('companyService', downgradeInjectable(CompanyApiService));

angular
  .module('risevision.apps.services')
  .factory('objectHelper', downgradeInjectable(ObjectHelperService));

angular
  .module('risevision.apps.services')
  .factory('FileUploaderService', downgradeInjectable(FileUploaderService));

angular
  .module('risevision.apps.services')
  .factory('encoding', downgradeInjectable(EncodingService));

angular
  .module('risevision.apps.services')
  .factory('downloadFactory', downgradeInjectable(DownloadService));

angular
  .module('risevision.apps.services')
  .value('WEBSITE_REGEX', ValidationService.WEBSITE_REGEX)
  .value('EMAIL_REGEX', ValidationService.EMAIL_REGEX)
  .value('CERTIFICATE_REGEX', ValidationService.CERTIFICATE_REGEX);

angular
  .module('risevision.apps.services')
  .factory(
    'localStorageService',
    downgradeInjectable(LocalStorageHelperService),
  );

angular
  .module('risevision.apps.services')
  .value('REGIONS_CA', GeodataService.REGIONS_CA)
  .value('REGIONS_US', GeodataService.REGIONS_US);

angular
  .module('risevision.apps.services')
  .factory('contactUtils', downgradeInjectable(ContactUtilsService));

angular
  .module('risevision.apps.services')
  .factory('addressFactory', downgradeInjectable(AddressService));

angular
  .module('risevision.apps.services')
  .factory('addressUtils', downgradeInjectable(AddressUtilsService));

angular
  .module('risevision.apps.services')
  .factory(
    'rvShareAppDetection',
    downgradeInjectable(RvshareAppDetectionService),
  );

angular
  .module('risevision.apps.services')
  .factory('userState', downgradeInjectable(UserStateService));

angular
  .module('risevision.apps.services')
  .factory('userAuthFactory', downgradeInjectable(UserAuthService));

angular
  .module('risevision.apps.services')
  .factory('rvTokenStore', downgradeInjectable(RvTokenStoreService));

angular
  .module('risevision.apps.services')
  .factory('openidConnect', downgradeInjectable(OpenidConnectService));

angular
  .module('risevision.apps.services')
  .factory('storage', downgradeInjectable(StorageApiService));

angular
  .module('risevision.apps.services')
  .factory('presentation', downgradeInjectable(PresentationApiService));

angular
  .module('risevision.apps.services')
  .factory('apiUtils', downgradeInjectable(ApiUtilsService));

angular
  .module('risevision.apps.services')
  .factory(
    'rejectOnTimeoutService',
    downgradeInjectable(RejectOnTimeoutService),
  )
  .factory('rejectOnTimeout', [
    'rejectOnTimeoutService',
    function (rejectOnTimeoutService: RejectOnTimeoutService) {
      return function (deferred, entry) {
        return rejectOnTimeoutService.rejectOnTimeout(deferred, entry);
      };
    },
  ])
  .factory('gapiLoaderService', downgradeInjectable(GapiLoaderService))
  .factory('gapiLoader', [
    'gapiLoaderService',
    function (gapiLoaderService: GapiLoaderService) {
      return function () {
        return gapiLoaderService.load();
      };
    },
  ])
  .factory(
    'gapiClientLoaderGeneratorService',
    downgradeInjectable(GapiClientLoaderGeneratorService),
  )
  .factory('gapiClientLoaderGenerator', [
    'gapiClientLoaderGeneratorService',
    function (
      gapiClientLoaderGeneratorService: GapiClientLoaderGeneratorService,
    ) {
      return function (libName, libVer, baseUrl) {
        return gapiClientLoaderGeneratorService.generate(
          libName,
          libVer,
          baseUrl,
        );
      };
    },
  ])
  .factory(
    'dedupingGeneratorService',
    downgradeInjectable(DedupingGeneratorService),
  )
  .factory('DedupingGenerator', [
    'dedupingGeneratorService',
    function (dedupingGeneratorService: DedupingGeneratorService) {
      return function (libName, libVer, baseUrl) {
        return dedupingGeneratorService.generate(libName, libVer, baseUrl);
      };
    },
  ])
  .factory('coreApiLoaderService', downgradeInjectable(CoreApiLoaderService))
  .factory('coreAPILoader', [
    'coreApiLoaderService',
    function (coreApiLoaderService: CoreApiLoaderService) {
      return function () {
        return coreApiLoaderService.load();
      };
    },
  ]);

angular
  .module('risevision.common.components.scrolling-list')
  .constant('STORAGE_CLIENT_ERROR', StorageUtilsService.STORAGE_CLIENT_ERROR);

angular
  .module('risevision.common.components')
  .factory('featuresService', downgradeInjectable(FeaturesService));
